import tw from 'tailwind-styled-components'

export const ButtonTimerClasses = `self-end w-fit hover:bg-primary hover:text-white h-16 pl-1 pr-0.5 py-0`

export const ButtonTimerContent = tw.div`flex items-center`

export const ButtonTimerContentText = tw.div`px-2 flex gap-1`
export const ButtonTimerContentPhone = tw.div`flex items-center justify-center bg-white p-2 h-14 w-14 rounded-full`
